"use client";
import { jsx } from "react/jsx-runtime";
import { useQueryParams } from "../QueryParamsProvider/QueryParamsProvider.js";
import { createContext, useContext } from "react";
const ProductTileContext = createContext(
  null
);
const ProductTileConfigProviderClient = ({
  children,
  productTileConfigData,
  isDomainInclusionDisabledByKeyword
}) => {
  const { queryParams } = useQueryParams();
  return /* @__PURE__ */ jsx(
    ProductTileContext.Provider,
    {
      value: {
        productTileConfigData,
        isDomainInclusionDisabledByKeyword,
        keyword: queryParams == null ? void 0 : queryParams.get("keyword")
      },
      children
    }
  );
};
const useProductTileConfig = () => {
  const context = useContext(ProductTileContext);
  if (!context) {
    throw new Error(
      "useProductTile must be used within a ProductTileConfigProvider"
    );
  }
  return context;
};
export {
  ProductTileConfigProviderClient,
  useProductTileConfig
};
